import { render, staticRenderFns } from "./VirtualMachine.vue?vue&type=template&id=4e28124e&"
import script from "./VirtualMachine.vue?vue&type=script&lang=js&"
export * from "./VirtualMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports